import React from 'react';
import { Header, Segment, Input, Icon } from 'semantic-ui-react';

class MessagesHeader extends React.Component {

  render() {

    // Intitial State
    const {channelName, numUniqueUsers, handleSearchChange, searchLoading, isPrivateChannel, handleStar, isChannelFavourited} = this.props;

    return (
      <Segment clearing>

        {/* Channel Title */}
        <Header fluid="true" as="h2" floated="left" style={{ marginBottom: 0 }}>
        <span>
          {channelName}{" "}
          {!isPrivateChannel && (
            <Icon 
              onClick={handleStar} name={isChannelFavourited ? "star" : "star outline"} 
              color={isChannelFavourited ? "yellow" : "black"}
            />
            )}
        </span>
        <Header.Subheader>{numUniqueUsers}</Header.Subheader>
        </Header>

        {/* Search Messages in Channel */}
        <Header floated="right">
          <Input 
            loading={searchLoading}
            onChange={handleSearchChange} 
            size="mini" icon="search" name="searchTerm" placeholder="Search Messages" />
        </Header>
      </Segment>
    );
  }
}

export default MessagesHeader;